import { createSelector } from 'reselect';

// Config
import {
  getClickAndCollectCountdownVisibleSelector,
  getCollectionDateTimeStringSelector,
  getCollectionPointDatesApiCallActiveSelector,
  getCollectionPointDetailsCallActiveSelector,
  getCutOffTimeSelector,
} from '@redux/reducers/click-and-collect/clickAndCollectSelector';
import {
  getDeliveryOptionsSelector,
  getDeliveryOptionsCollectionPlusAvailableSelector,
} from '@redux/reducers/delivery/deliverySelector';
import { getUserSavedCollectionPointsSelector } from '@redux/reducers/user/userSelector';

const clickAndCollectSelectedPointState = createSelector(
  [
    getCollectionDateTimeStringSelector,
    getClickAndCollectCountdownVisibleSelector,
    getCutOffTimeSelector,
    getDeliveryOptionsSelector,
    getUserSavedCollectionPointsSelector,
    getCollectionPointDetailsCallActiveSelector,
    getCollectionPointDatesApiCallActiveSelector,
    getDeliveryOptionsCollectionPlusAvailableSelector,
  ],
  (
    collectFromTime,
    countdownVisible,
    cutOffTimeForSelectedStore,
    deliveryOptions,
    savedCollectionPoints,
    getCollectionPointDetailsCallActive,
    getCollectionPointDatesApiCallActive,
    collectPlusAvailable,
  ) => ({
    collectFromTime,
    countdownVisible,
    cutOffTimeForSelectedStore,
    deliveryOptions,
    savedCollectionPoints,
    isSelectCollectionPointCallActive: getCollectionPointDetailsCallActive || getCollectionPointDatesApiCallActive,
    collectPlusAvailable,
  }),
);

export default clickAndCollectSelectedPointState;
